import * as Sentry from '@sentry/react';

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  
  if (!dsn) {
    console.warn('Sentry DSN not configured. Error tracking will be disabled.');
    return;
  }

  // Get release version from environment or use git commit SHA
  const release = import.meta.env.VITE_SENTRY_RELEASE || 
                   import.meta.env.VITE_GIT_COMMIT_SHA || 
                   undefined;

  Sentry.init({
    dsn,
    release, // Associate errors with source maps using release version
    sendDefaultPii: true,
    enableLogs: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0, // 10% in production, 100% in dev
    // Session Replay
    replaysSessionSampleRate: import.meta.env.PROD ? 0.1 : 1.0, // 10% in production, 100% in dev
    replaysOnErrorSampleRate: 1.0, // 100% of sessions with errors
    
    environment: import.meta.env.MODE,
    enabled: import.meta.env.PROD || !!dsn,
    
    // Set user context when available
    beforeSend(event) {
      // Don't send errors in development unless explicitly enabled
      if (import.meta.env.DEV && !import.meta.env.VITE_SENTRY_ENABLE_DEV) {
        return null;
      }
      return event;
    },
  });
}

export { Sentry };

